import { render, staticRenderFns } from "./editPrize.vue?vue&type=template&id=c01ea9dc&scoped=true&"
import script from "./editPrize.vue?vue&type=script&lang=js&"
export * from "./editPrize.vue?vue&type=script&lang=js&"
import style0 from "./editPrize.vue?vue&type=style&index=0&id=c01ea9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01ea9dc",
  null
  
)

export default component.exports